import { render, staticRenderFns } from "./shared.vue?vue&type=template&id=cf3ff858&"
import script from "./shared.vue?vue&type=script&lang=js&"
export * from "./shared.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports